import { User } from '@/api/types/public';
import { ProviderType, TrackingEvent } from '../types';

export function signupAdapter(
  data: { userInfo: User; registerType?: 'email' | 'fast_register' },
  provider: ProviderType,
  eventId?: string,
): TrackingEvent | TrackingEvent[] | null {
  const { userInfo, registerType } = data;
  switch (provider) {
    case ProviderType.EMARSYS:
      return {
        eventName: 'signup',
        eventId,
        properties: {
          uuid: `${userInfo?.id}`,
        },
      };
    case ProviderType.SNAPCHAT:
      return {
        commandType: 'track',
        eventName: 'SIGN_UP',
        eventId,
        properties: {},
      };
    case ProviderType.SNAPCHAT_CONVERSION:
      return {
        commandType: 'track',
        eventName: 'SIGN_UP',
        eventId,
        properties: {},
      };
    case ProviderType.FACEBOOK:
      return {
        eventName: 'CompleteRegistration',
        eventId,
        properties: {},
      };
    case ProviderType.TIKTOK: {
      return {
        eventName: 'Registration',
        eventId,
        properties: {
          event_id: eventId || `reg_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`, // 优先使用统一的 eventId
        },
      };
    }
    case ProviderType.APPLOVIN: {
      const aleid = localStorage.getItem('zl_axon_aleid');
      return [
        {
          eventName: 'sign_up',
          eventId,
          properties: {
            method: 'email',
            user_id: `${userInfo.id}`,
          },
        },
        {
          eventName: 'generate_lead',
          eventId,
          properties: {
            user_id: `${userInfo.id}&${aleid}`,
          },
        },
      ];
    }
    case ProviderType.TWITTER:
      return [
        {
          eventName: 'tw-of32e-of32o',
          eventId,
          properties: {},
        },
        {
          eventName: 'tw-of2hc-of326',
          eventId,
          properties: {},
        },
      ];
    case ProviderType.GA4:
      return {
        commandType: 'event',
        eventName: 'sign_up',
        eventId,
        properties: {
          event_label: 'register',
          event_category: registerType || 'email',
        },
      };
    case ProviderType.BING:
      return {
        eventName: 'buttonclick',
        eventId,
        properties: { event_category: 'register', event_label: 'click', event_value: '1' },
      };
    case ProviderType.SNOWPLOW:
      return {
        eventName: 'SignUp_Result',
        eventId,
        properties: {
          user_id: String(userInfo?.id || ''),
          register_type: registerType || 'email',
        },
      };
    default:
      return null;
  }
}
